/**
 * Enum trạng thái
 * Dùng trong bộ lọc
 * VDDONG 23/05/2023
 */
export default {
  Active: 1,
  Inactive: 0,
};
